// All orders related apis
import { API_URL } from "./api";
import instance from "./api";
import { encryptData } from "../helpers/encryptDecrypt";

// Get api for fetching orders for active organization and branch with filter options
export const fetchOrdersByOrganizationAndBranch = async (
  organizationId,
  branchId,
  filter_type,
  payment_type,
  start_date,
  end_date,
  search_keyword,
  page,
  limit,
  type
) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);
  return await instance.get(
    `${API_URL}/orders/filtered?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&payment_type=${payment_type}&start_date=${start_date}&end_date=${end_date}&keyword=${search_keyword}&page=${page}&limit=${limit}&type=${type}`
  );
};

// Get api for fetching orders summary for the active organization and branch with filters and pagination options
export const fetchOrdersSummaryByOrganizationAndBranch = async (
  organizationId,
  branchId,
  filter_type,
  payment_type,
  start_date,
  end_date,
  uId,
  type
) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);

  return await instance.get(
    `${API_URL}/sales/revenue-summary?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&payment_type=${payment_type}&start_date=${start_date}&end_date=${end_date}&uId=${uId}&isOrder=true&type=${type}`
  );
};

// Get api for fetching orders to download for the active organization and branch with filters and pagination options
export const fetchOrdersToDownloadByOrganizationAndBranch = async (
  organizationId,
  branchId,
  filter_type,
  payment_type,
  start_date,
  end_date,
  uId,
  type
) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);

  return await instance.get(
    `${API_URL}/sales/download?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&payment_type=${payment_type}&start_date=${start_date}&end_date=${end_date}&uId=${uId}&isOrder=true&type=${type}`
  );
};

// Get api for fetching orders for selected user with filter options
export const fetchOrdersByUser = async (
  userId,
  organizationId,
  branchId,
  filter_type,
  payment_type,
  start_date,
  end_date,
  search_keyword,
  page,
  limit,
  type
) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);
  const uId = encryptData(userId);

  return await instance.get(
    `${API_URL}/orders/by-user/${uId}?organizationId=${oId}&branchId=${bId}&filter_type=${filter_type}&payment_type=${payment_type}&start_date=${start_date}&end_date=${end_date}&keyword=${search_keyword}&page=${page}&limit=${limit}&type=${type}`
  );
};

// Post api changing order to sale (not in use)
export const changeOrderToSale = async (orderId) => {
  const oId = encryptData(orderId);

  return await instance.post(`${API_URL}/sales/convert/${oId}`);
};

// Post api for changing order to sale with updated data
export const convertOrderToSale = async (orderId, data) => {
  const oId = encryptData(orderId);

  return await instance.post(
    `${API_URL}/sales/change-order-to-sale/${oId}`,
    data
  );
};

// Fetch all orders (not in use)
export const fetchAllOrders = async () => {
  const response = await instance.get(`${API_URL}/orders`);
  return response.data;
};
